import { Stack, TextField } from "@mui/material";
import Translate from "./Translate";
import { DatePicker } from "@mui/x-date-pickers";
import { getCurrentDateMask, getCurrentInputFormat, isValidDate } from "./dateTimeFormat";
import { useState } from "react";
import { accessKeys, hasSomeAccess } from "./userAccess";

export default function DateInterval({ item, applyValue }) {
  const [startDate, setStartDate] = useState(item.value?.[0] || null);
  const [endDate, setEndDate] = useState(item.value?.[1] || null);

  const handleChange = (newStartDate, newEndDate) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    applyValue({ ...item, value: [newStartDate, newEndDate] });
  };

  return (
    <Stack spacing={2}>
      <DatePicker
        displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
        label={Translate.get("StartDate")}
        value={startDate}
        format={getCurrentInputFormat()}
        mask={getCurrentDateMask()}
        onChange={(newValue) => {
          if (isValidDate(newValue)) {
            handleChange(newValue, endDate);
          }
        }}
        slotProps={{ textField: { variant: "standard" } }}
      />
      <DatePicker
        displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
        label={Translate.get("EndDate")}
        value={endDate}
        format={getCurrentInputFormat()}
        mask={getCurrentDateMask()}
        onChange={(newValue) => {
          if (isValidDate(newValue)) {
            handleChange(startDate, newValue);
          }
        }}
        slotProps={{ textField: { variant: "standard" } }}
      />
    </Stack>
  );
}
